import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../context/StoreContext";
import { CourseThumb, Stars, fmtCount } from "../lib/art";
import { fmtPrice } from "../lib/api";

export const CourseCard = ({ c, secMap }) => {
  const { wishlist, toggleWishlist, currency } = useStore();
  const nav = useNavigate();
  const ref = useRef(null);
  const sec = secMap?.[c.section] || {};
  const wished = wishlist.includes(c.id);
  const onSale = c.effective_price < c.price;
  const hrs = Math.floor((c.total_duration_min || 0) / 60);

  const tilt = (e) => {
    const el = ref.current;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
    el.style.transform = `perspective(900px) rotateY(${(x - 0.5) * 9}deg) rotateX(${(0.5 - y) * 7}deg) translateY(-4px)`;
    el.style.setProperty("--gx", x * 100 + "%");
    el.style.setProperty("--gy", y * 100 + "%");
  };

  return (
    <div ref={ref} className="card" data-testid={`course-card-${c.id}`}
      style={{ "--glow": sec.color === "land" ? "var(--land)" : "var(--bp)" }}
      onClick={() => nav(`/course/${c.id}`)} onMouseMove={tilt}
      onMouseLeave={() => { ref.current.style.transform = ""; }}>
      {c.bestseller && <span className="bs-badge">BESTSELLER</span>}
      <button className={`heart ${wished ? "on" : ""}`} data-testid={`wishlist-btn-${c.id}`} title="Save to My List"
        onClick={(e) => { e.stopPropagation(); toggleWishlist(c.id); }}>{wished ? "♥" : "♡"}</button>
      <div className="thumb">
        <CourseThumb course={c} color={sec.color} />
        <div className="play"><div className="play-btn"><svg width="18" height="18" viewBox="0 0 24 24" fill="#04121f"><path d="M8 5v14l11-7z" /></svg></div></div>
      </div>
      <div className="card-body">
        <h3>{c.title}</h3>
        <div className="instructor">{c.instructor}</div>
        <div className="rating-row">
          <span className="rv">{(c.rating || 0).toFixed(1)}</span>
          <Stars r={c.rating || 0} />
          <span className="rc">({fmtCount(c.rating_count)})</span>
        </div>
        <div className="meta-line">{hrs} total hours · {c.lecture_count} lectures · {c.level}</div>
        <div className="price-row">
          <span className={`now ${c.effective_price === 0 ? "free" : ""}`} data-testid={`price-${c.id}`}>
            {c.effective_price === 0 ? "FREE" : fmtPrice(c.effective_price, currency)}
          </span>
          {onSale && <span className="old">{fmtPrice(c.price, currency)}</span>}
          <span className="lvl">{c.level.toUpperCase()}</span>
        </div>
      </div>
    </div>
  );
};
